import React from 'react';
import {Button} from "reactstrap";

const AppButton = (props) => {
    const onClick = (link) =>{
        window.open(link,'_blank')
    }
    return(
        <>           
            <button onClick={()=>onClick(props.link)} className={'app-button'}
            >{props.name}</button>
        </>
    )
};

export default AppButton;